/* eslint-disable camelcase */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect, useRef } from "react";
import {
    Modal,
    Upload,
    Button,
    Spin,
    notification,
    Alert
} from "antd";
import {
    DeleteOutlined,
    CloudUploadOutlined,
    FileOutlined,
    UploadOutlined,
    CloseOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OneIntelligenceServices from "../../services/OneIntelligence.services";
import { getCountryCode } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { setBuildTargetFromLoadedJson, setCountryNotAvailable } from "../../store/components/BuildTargets.slice";
import { setMarketExplorerFromLoadedJson } from "../../store/components/MarketExplorer.slice";
import { setReportBuilderFromLoadedJson } from "../../store/components/ReportBuilder.slice";
import { setReportsFromLoadedJson } from "../../store/components/Reports.slice";
// import { setBuildTargetFromLoadedJson, setCountryNotAvailable } from "store/components/BuildTargets.slice";
// import { setMarketExplorerFromLoadedJson } from "store/components/MarketExplorer.slice";
// import { setReportBuilderFromLoadedJson } from "store/components/ReportBuilder.slice";
// import { setReportsFromLoadedJson } from "store/components/Reports.slice";
// import { getCountryCode } from "utils/oneintelligence/OneIntelligenceHelper";
// import OneIntelligenceServices from "services/OneIntelligence.services";

const { Dragger } = Upload;

function LoadAnalysis({
    visible,
    onClose = () => { }
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [existList, setExistList] = useState([]);
    const [loadedJson, setloadedJson] = useState({});
    const [countryNotAvailable, setcountryNotAvailableState] = useState(false);
    const [countryName, setcountryName] = useState("");

    const uploaderRef = useRef(null);

    const all = useSelector((state) => state);

    const {
        buildTargets: {
            quickReportsAndCountry
        }
    } = all;
    const draggerProps = {
        className: "oi-uploader",
        name: "file",
        multiple: false,
        accept: ".oijson",
        listType: "picture",
        fileList,
        progress: {
            strokeWidth: 3,
            strokeColor: {
                "0%": "#1890FF",
                "100%": "#52C41A"
            }
        },
        showUploadList: {
            showRemoveIcon: !uploading
        },
        maxCount: 1,
        ref: uploaderRef,
        disabled: uploading,
        beforeUpload: () => false,
        onChange: ({ file, fileList: list }) => {
            const {
                name, status, uid, type
            } = file;
            if (status === "done" && !existList.includes(uid)) {
                openNotification(
                    "success",
                    "Creative Upload File",
                    `${name} file uploaded successfully.`,
                    0
                );
            } else if (status === "error") {
                openNotification(
                    "error",
                    "Creative Upload File",
                    `${name} file upload failed. Please try again.`,
                    0
                );
            }
            if (type === "application/json") setFileList([file]);
            else if (!type && name.includes("oijson")) setFileList([file]);
        },
        onClick: () => {
            setExistList([]);
        },
        itemRender: () => { },
        iconRender: (file) => {
            if (file.status === "uploading") return <Spin />;
            return <FileOutlined />;
        }
    };

    const openNotification = (type, title, msg, duration = 0) => {
        notification[type]({
            message: title,
            description: msg,
            duration,
            maxCount: 7
        });
    };

    useEffect(() => {
        setFileList([]);
        notification.destroy();
        notification.destroy("exist-file");
    }, [visible]);

    useEffect(() => {
        if (fileList.length) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const obj = JSON.parse(event.target.result);
                const {
                    data: {
                        buildTargets: {
                            setup: {
                                country
                            }
                        }
                    }
                } = obj;
                try {
                    const serverObj = OneIntelligenceServices.getSavantCountryObj(country.savantCode);
                    setcountryNotAvailableState(!serverObj);
                } catch (error) {
                    setcountryNotAvailableState(false);
                }

                setloadedJson(obj);
                setcountryName(country.name);
            };
            reader.readAsText(fileList[0]);
        } else {
            setcountryNotAvailableState(false);
            setloadedJson({});
            setcountryName("");
        }
    }, [fileList, quickReportsAndCountry]);
    return (
        <Modal
            className="creativeupload"
            title={(
                <div className="d-flex justify-content-between">
                    <div className="d-flex-col">
                        <div className="d-flex align-items-center gap-5p">
                            <UploadOutlined />
                            <span className="fw-600 fs-16">Load Dashboard</span>
                        </div>
                        <span className="fw-400 fs-14 c-bg-400">Upload OIJSON file from your local drive.</span>
                    </div>
                    <Button
                        style={{ padding: 0, marginLeft: "5mm" }}
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => {
                            onClose(false);
                        }}
                    />
                </div>
            )}
            centered
            closable={false}
            open={visible}
            width={600}
            height={500}
            destroyOnClose
            bodyStyle={{
                maxHeight: fileList.length ? "150mm" : "80mm"
            }}
            maskClosable={false}
            footer={(
                <div>
                    <Button
                        disabled={uploading}
                        onClick={() => { onClose(false); }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="om-btn-footer"
                        disabled={uploading || !fileList.length || countryNotAvailable}
                        type="primary"
                        onClick={() => {
                            const {
                                buildTargets, reportBuilder, marketExplorer, reports
                            } = loadedJson.data;
                            window.sq.oneintel.isLoadedAnalysis = true;
                            dispatch(setBuildTargetFromLoadedJson(buildTargets));
                            dispatch(setMarketExplorerFromLoadedJson(marketExplorer));
                            dispatch(setReportBuilderFromLoadedJson(reportBuilder));
                            dispatch(setReportsFromLoadedJson(reports));

                            navigate("/advanced");
                            onClose(false);
                            setTimeout(() => {
                                window.sq.oneintel.isLoadedAnalysis = false;
                            }, 1000);
                        }}
                    >
                        Upload
                    </Button>
                </div>
            )}
        >
            <Dragger {...draggerProps}>
                {!fileList.length ? (
                    <>
                        <p className="ant-upload-drag-icon">
                            <CloudUploadOutlined />
                        </p>
                        <p className="ant-upload-text">
                            Drag and drop the OIJSON files you would like to upload, or
                            <strong
                                style={{
                                    marginLeft: "1mm",
                                    textDecoration: "underline",
                                    color: "#1890ff"
                                }}
                            >
                                Browse
                            </strong>
                        </p>
                    </>
                ) : (

                    <div style={{ width: "100%", padding: "4mm" }}>
                        {fileList.map((file) => (
                            <div
                                className="d-flex align-items-center justify-content-between"
                                key={file.uid}
                                style={{
                                    padding: "1mm 3mm",
                                    border: "1px solid var(--bluegray-100)",
                                    backgroundColor: "white",
                                    height: "51px"
                                }}
                            >
                                <div className="d-flex align-items-center gap-5p">
                                    <FileOutlined />
                                    <span>{file.name}</span>
                                </div>
                                <DeleteOutlined
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setFileList(fileList.filter((f) => f.uid !== file.uid));
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </Dragger>
            {countryNotAvailable && (
                <Alert
                    style={{
                        marginTop: "2mm"
                    }}
                    message={(
                        <span style={{
                            fontWeight: "400",
                            fontSize: "14px"
                        }}
                        >
                            {`${countryName} country is currently not available to this version.`}
                        </span>
                    )}
                    showIcon
                    description={(
                        <span style={{
                            fontWeight: "400",
                            fontSize: "14px"
                        }}
                        >
                            Do you want to continue?
                        </span>
                    )}
                    type="error"
                    action={(
                        <Button
                            size="small"
                            onClick={() => {
                                setcountryNotAvailableState(false);
                                dispatch(setCountryNotAvailable(true));
                            }}
                        >
                            Continue
                        </Button>
                    )}
                />
            )}
        </Modal>
    );
}

export default LoadAnalysis;
